import { useAuth } from '@/context/AuthContext';
import { auth } from '@/lib/firebase';
import { signOut, sendEmailVerification } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

export default function VerifyEmail() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [message, setMessage] = useState('');

  const handleReload = async () => {
    if (user) {
      await user.reload();
      // Nota: El objeto user puede no actualizarse inmediatamente después de reload()
      // Es mejor recargar la página completa o confiar en que Firebase Auth lo detecte.
      window.location.reload();
    }
  };

  const handleResend = async () => {
    if (user) {
      try {
        await sendEmailVerification(user);
        setMessage('Correo de verificación reenviado.');
      } catch (err: any) {
        setMessage(`Error: ${err.message}`);
      }
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/crm/login');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 to-indigo-950 text-white font-sans">
      <div className="max-w-md w-full p-8 bg-slate-800/50 backdrop-blur-xl rounded-2xl shadow-2xl border border-slate-700/50 text-center">
        <div className="mb-6">
          <div className="w-16 h-16 bg-purple-500/10 text-purple-500 rounded-full flex items-center justify-center mx-auto mb-4 border border-purple-500/20">
            <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
            </svg>
          </div>
          <h1 className="text-3xl font-bold mb-2">Verifica tu correo</h1>
          <p className="text-slate-400 text-sm">
            Hemos enviado un correo de verificación a <span className="text-white font-medium">{user?.email}</span>.
          </p>
          <p className="text-slate-400 text-sm mt-1">
            Por favor, revisa tu bandeja de entrada y haz clic en el enlace para continuar.
          </p>
        </div>

        {message && (
          <div className="bg-purple-500/10 border border-purple-500/50 text-purple-400 p-3 rounded-lg mb-6 text-sm">
            {message}
          </div>
        )}

        <div className="space-y-3">
          <button
            onClick={handleReload}
            className="w-full p-3 bg-gradient-to-r from-emerald-500 to-cyan-500 hover:from-emerald-600 hover:to-cyan-600 rounded-lg font-semibold transition-all duration-300 transform hover:scale-[1.02]"
          >
            Ya lo verifiqué
          </button>
          
          <button
            onClick={handleResend}
            className="w-full p-3 bg-slate-700 hover:bg-slate-600 rounded-lg font-semibold transition-colors text-sm"
          >
            Reenviar correo
          </button>
          
          <button
            onClick={handleLogout}
            className="w-full p-3 bg-transparent hover:bg-white/5 rounded-lg font-semibold transition-colors text-sm text-slate-400 hover:text-white"
          >
            Cerrar Sesión
          </button>
        </div>
      </div>
    </div>
  );
}
